import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _ModerateTable;
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Text } from '@instructure/ui-text';
import { Link } from '@instructure/ui-link';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { Table } from '@instructure/ui-table';
import { IconButton } from '@instructure/ui-buttons';
import { IconInfoLine, IconConfigureLine } from '@instructure/ui-icons';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/format-message';
import ModerateTableRow from '../ModerateTableRow';
import IfFeature from '../../../../common/components/shared/IfFeature';
import OutstandingQuizzesModal from '../OutstandingQuizzesModal';
import ModerateTray from '../../sidebar/ModerateTray';
import Spinner from '../../../../common/components/shared/spinner/Spinner';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import ResetQuiz from '../../sidebar/ResetQuiz';
import { Flex, OUTSTANDING_QUIZZES_MODAL, withStyleOverrides } from '@instructure/quiz-common';
import { chunk } from 'lodash';
export var ModerateTable = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_ModerateTable = /*#__PURE__*/function (_Component) {
  function ModerateTable() {
    var _this2;
    _classCallCheck(this, ModerateTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, ModerateTable, [].concat(args));
    _defineProperty(_this2, "state", {
      displayScoreAsPercentage: true,
      // To support voiceover when the table changes
      moderatePanelIterations: 0,
      selectedStudent: null,
      // To display the spinner while manually submitted quiz sessions are being graded
      isWaiting: false
    });
    _defineProperty(_this2, "fetchData", function () {
      var _this2$props = _this2.props,
        getQuizSessions = _this2$props.getQuizSessions,
        quizId = _this2$props.quizId,
        inProgressData = _this2$props.inProgressData,
        tableData = _this2$props.tableData;
      var quizSessionIds = _toConsumableArray(new Set([].concat(_toConsumableArray(_this2.quizSessionIds(inProgressData)), _toConsumableArray(_this2.quizSessionIds(tableData)))));

      // NOTE: The consumer provided no quizSessionIds. Don't fetch
      if (!quizSessionIds.length) return;
      chunk(quizSessionIds, 25).forEach(function (chunkedIds) {
        getQuizSessions(quizId, {
          ids: chunkedIds
        });
      });
    });
    _defineProperty(_this2, "onModerateButtonClick", function (data) {
      _this2.setState({
        selectedStudent: data.id
      });
      _this2.props.onOpenTray(data);
      _this2.props.openTray(data);
    });
    _defineProperty(_this2, "onCloseTray", function () {
      _this2.props.onCloseTray();
      _this2.setState({
        moderatePanelIterations: _this2.state.moderatePanelIterations + 1
      });
    });
    _defineProperty(_this2, "sessionsStillAutograding", function (quizzesToSubmit) {
      var _iterator = _createForOfIteratorHelper(_this2.props.quizSessionsData),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var quizSession = _step.value;
          if (quizzesToSubmit.indexOf(quizSession.id) > -1 && (quizSession.status === 'autograding' || quizSession.status === 'in_progress')) {
            return true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return false;
    });
    _defineProperty(_this2, "checkAutogradingStatus", function (submittedQuizSessions) {
      if (_this2.sessionsStillAutograding(submittedQuizSessions)) {
        _this2.pollAutogradingStatus(submittedQuizSessions);
      } else {
        _this2.setState({
          isWaiting: false
        });
        _this2.props.addSuccess(t('Manual submission was successful.'));
      }
    });
    _defineProperty(_this2, "pollAutogradingStatus", function (submittedQuizSessions) {
      _this2.fetchData();
      setTimeout(function () {
        _this2.checkAutogradingStatus(submittedQuizSessions);
      }, 1000);
    });
    _defineProperty(_this2, "handleSubmissionAndPoll", function (submittedQuizSessions) {
      _this2.setState({
        isWaiting: true
      });
      _this2.pollAutogradingStatus(submittedQuizSessions);
    });
    _defineProperty(_this2, "handleScoreToggle", function () {
      _this2.setState(function (prevState) {
        return {
          displayScoreAsPercentage: !prevState.displayScoreAsPercentage
        };
      });
    });
    _defineProperty(_this2, "scoreToggleScreenreaderMessage", function () {
      return _this2.state.displayScoreAsPercentage ? t('Toggle scores to raw points') : t('Toggle scores to percentages');
    });
    _defineProperty(_this2, "openModalOnClick", function () {
      _this2.props.openModal(OUTSTANDING_QUIZZES_MODAL);
    });
    return _this2;
  }
  _inherits(ModerateTable, _Component);
  return _createClass(ModerateTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.makeStyles({
        displayScoreAsPercentage: this.state.displayScoreAsPercentage
      });
      this.fetchData();
      var _this$props = this.props,
        hasSessionTimeLimit = _this$props.hasSessionTimeLimit,
        sessionTimeLimitInSeconds = _this$props.sessionTimeLimitInSeconds;
      this.props.sendSessionTimeLimit({
        hasSessionTimeLimit: hasSessionTimeLimit,
        sessionTimeLimitInSeconds: sessionTimeLimitInSeconds
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.props.makeStyles({
        displayScoreAsPercentage: this.state.displayScoreAsPercentage
      });
      var _this$props2 = this.props,
        hasSessionTimeLimit = _this$props2.hasSessionTimeLimit,
        sessionTimeLimitInSeconds = _this$props2.sessionTimeLimitInSeconds;
      if (prevProps.hasSessionTimeLimit !== hasSessionTimeLimit || prevProps.sessionTimeLimitInSeconds !== sessionTimeLimitInSeconds) {
        this.props.sendSessionTimeLimit({
          hasSessionTimeLimit: hasSessionTimeLimit,
          sessionTimeLimitInSeconds: sessionTimeLimitInSeconds
        });
      }
      if (prevProps.tableData != this.props.tableData) {
        this.setState({
          selectedStudent: null
        });
      }
      var quizSessionIds = _toConsumableArray(new Set([].concat(_toConsumableArray(this.quizSessionIds(this.props.inProgressData)), _toConsumableArray(this.quizSessionIds(this.props.tableData)))));
      var prevQuizSessionIds = _toConsumableArray(new Set([].concat(_toConsumableArray(this.quizSessionIds(prevProps.inProgressData)), _toConsumableArray(this.quizSessionIds(prevProps.tableData)))));
      var skipFetchData = quizSessionIds.every(function (id, index) {
        return id === prevQuizSessionIds[index];
      });
      if (skipFetchData) return;
      this.fetchData();
    }
  }, {
    key: "quizSessionIds",
    value: function quizSessionIds(data) {
      return data.reduce(function (ids, _ref) {
        var quizSessionIds = _ref.quizSessionIds;
        return ids.concat(quizSessionIds);
      }, []).sort();
    }
  }, {
    key: "renderTableRows",
    value:
    // =============
    //   RENDERING
    // =============

    function renderTableRows() {
      var _this3 = this;
      var _this$props3 = this.props,
        onModerateLogClick = _this$props3.onModerateLogClick,
        onResultsLinkClick = _this$props3.onResultsLinkClick,
        shouldRenderModerateButton = _this$props3.shouldRenderModerateButton;
      return this.props.tableData.map(function (rowData) {
        var id = rowData.id;
        return jsx(ModerateTableRow, {
          anonymousGrading: _this3.props.anonymousGrading,
          onResultsLinkClick: onResultsLinkClick,
          onAccommodationsClick: _this3.props.onAccommodationsClick,
          key: "".concat(id, "-").concat(_this3.state.moderatePanelIterations),
          onModerateButtonClick: _this3.onModerateButtonClick,
          onModerateLogClick: onModerateLogClick,
          rowData: rowData,
          shouldRenderModerateButton: shouldRenderModerateButton,
          focusTarget: _this3.state.selectedStudent,
          displayScoreAsPercentage: _this3.state.displayScoreAsPercentage
        });
      });
    }
  }, {
    key: "countOutstandingAttempts",
    value: function countOutstandingAttempts() {
      var i = 0;
      if (!this.props.quizSessionsData) {
        return 0;
      }
      var _iterator2 = _createForOfIteratorHelper(this.props.quizSessionsData),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var quiz = _step2.value;
          if (quiz.status === 'in_progress') {
            i += 1;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return i;
    }
  }, {
    key: "renderAlertContent",
    value: function renderAlertContent(outstandingAttemptsCount) {
      var _this4 = this;
      return jsx("div", null, jsx(IfFeature, {
        name: "manual_submission"
      }, jsx(Flex, null, jsx(Flex.Item, null, jsx(IconInfoLine, null)), jsx(Flex.Item, {
        padding: "xx-small"
      }, t.rich('This assessment has <0>{count, plural, one {# attempt} other {# attempts}}</0> in progress.', {
        count: outstandingAttemptsCount,
        0: function _(_ref2) {
          var children = _ref2.children;
          return jsx(Link, {
            key: "0",
            onClick: _this4.openModalOnClick,
            "data-automation": "sdk-outstanding-quizzes-modal-open"
          }, children);
        }
      })))), jsx(IfFeature, {
        name: "manual_submission"
      }, jsx(OutstandingQuizzesModal, {
        quizSessionsData: this.props.quizSessionsData,
        quizSessionIdsAndUsers: this.props.quizSessionIdsAndUsers,
        handleSubmissionAndPoll: this.handleSubmissionAndPoll,
        afterSubmit: this.props.afterManualSubmit
      })));
    }
  }, {
    key: "renderScoreToggle",
    value: function renderScoreToggle() {
      return jsx("div", {
        css: this.props.styles.scoreToggleWrapper
      }, jsx(IconButton, {
        size: "small",
        margin: "0 x-small",
        withBackground: false,
        withBorder: false,
        screenReaderLabel: this.scoreToggleScreenreaderMessage(),
        onClick: this.handleScoreToggle,
        "data-automation": "moderation-table-score-toggle"
      }, jsx(IconConfigureLine, null)));
    }
  }, {
    key: "renderTable",
    value: function renderTable() {
      var outstandingAttemptsCount = this.countOutstandingAttempts();
      return jsx("div", {
        className: "fs-mask"
      }, outstandingAttemptsCount ? this.renderAlertContent(outstandingAttemptsCount) : null, jsx(Table, {
        caption: t('Moderation Table')
      }, jsx(Table.Head, null, jsx(Table.Row, null, jsx(Table.ColHeader, {
        id: "moderation-table-student"
      }, t('Student')), !this.props.anonymousGrading && jsx(Table.ColHeader, {
        id: "moderation-table-attempts"
      }, t('Attempts')), !this.props.anonymousGrading && jsx(Table.ColHeader, {
        id: "moderation-table-score"
      }, t('Score'), this.renderScoreToggle()), !this.props.anonymousGrading && jsx(Table.ColHeader, {
        id: "moderation-table-time"
      }, t('Time')), !this.props.anonymousGrading && jsx(Table.ColHeader, {
        id: "moderation-table-log"
      }, t('Log')), this.props.onAccommodationsClick && !this.props.anonymousGrading && jsx(Table.ColHeader, {
        id: "moderation-table-accommodations"
      }, t({
        "default": 'Accommodations',
        description: 'Support for students with who need extra time or attempts.'
      })), this.props.shouldRenderModerateButton && jsx(Table.ColHeader, {
        id: "moderation-table-moderate"
      }, jsx(ScreenReaderContent, null, t('Moderate'))))), jsx(Table.Body, null, this.renderTableRows())));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props4 = this.props,
        isFetching = _this$props4.isFetching,
        tableData = _this$props4.tableData,
        emptyMessage = _this$props4.emptyMessage;
      if (isFetching || this.state.isWaiting) return jsx(Spinner, null);
      if (tableData.length) return this.renderTable();
      return jsx("span", {
        css: this.props.styles.emptyText
      }, jsx(Text, {
        color: "primary"
      }, emptyMessage));
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", {
        css: this.props.styles.page
      }, jsx(ModerateTray, {
        onClose: this.onCloseTray,
        onSave: this.props.onSaveTray,
        atteqApplyChangesToCurrentQuizAttemptsEnabled: this.props.atteqApplyChangesToCurrentQuizAttemptsEnabled
      }, jsx(Flex.Item, null, !this.props.anonymousGrading && jsx(ResetQuiz, null)), this.props.children), this.renderContent());
    }
  }]);
}(Component), _defineProperty(_ModerateTable, "displayName", 'ModerateTable'), _defineProperty(_ModerateTable, "componentId", "Quizzes".concat(_ModerateTable.displayName)), _defineProperty(_ModerateTable, "propTypes", {
  anonymousGrading: PropTypes.bool,
  children: PropTypes.node,
  emptyMessage: PropTypes.string,
  isFetching: PropTypes.bool.isRequired,
  onCloseTray: PropTypes.func,
  onModerateLogClick: PropTypes.func.isRequired,
  onAccommodationsClick: PropTypes.func,
  onOpenTray: PropTypes.func,
  onResultsLinkClick: PropTypes.func,
  openTray: PropTypes.func.isRequired,
  onSaveTray: PropTypes.func.isRequired,
  sessionTimeLimitInSeconds: PropTypes.number,
  hasSessionTimeLimit: PropTypes.bool,
  sendSessionTimeLimit: PropTypes.func,
  shouldRenderModerateButton: PropTypes.bool,
  openModal: PropTypes.func.isRequired,
  quizSessionIdsAndUsers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  })),
  quizSessionsData: ImmutablePropTypes.listOf(ImmutablePropTypes.record).isRequired,
  afterManualSubmit: PropTypes.func,
  inProgressData: PropTypes.arrayOf(PropTypes.shape({
    avatar: PropTypes.string,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    quizSessionIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    maxAttempts: PropTypes.number,
    accommodations: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    }))
  })).isRequired,
  tableData: PropTypes.arrayOf(PropTypes.shape({
    avatar: PropTypes.string,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    quizSessionIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    maxAttempts: PropTypes.number,
    accommodations: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    }))
  })).isRequired,
  quizId: PropTypes.string.isRequired,
  getQuizSessions: PropTypes.func.isRequired,
  addSuccess: PropTypes.func.isRequired,
  styles: PropTypes.object,
  makeStyles: PropTypes.func,
  atteqApplyChangesToCurrentQuizAttemptsEnabled: PropTypes.bool.isRequired
}), _defineProperty(_ModerateTable, "defaultProps", {
  anonymousGrading: false,
  children: void 0,
  emptyMessage: t('There is no moderation information to display yet.'),
  onCloseTray: Function.prototype,
  onOpenTray: Function.prototype,
  sendSessionTimeLimit: Function.prototype,
  sessionTimeLimitInSeconds: null,
  hasSessionTimeLimit: false,
  shouldRenderModerateButton: true,
  onAccommodationsClick: null,
  onOutstandingQuizzesClick: void 0,
  onResultsLinkClick: void 0,
  quizSessionIdsAndUsers: [],
  afterManualSubmit: Function.prototype
}), _ModerateTable)) || _class);
export default ModerateTable;